module.exports = __webpack_public_path__ + "static/fonts/iconfont.06a5fb4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/fonts/iconfont.ttf?v=1.0.0
// module id = uDAk
// module chunks = 34